import { useState } from 'react';
import { CustomDialogProps } from '@/dashboard/components/Dialog/index';
import LogoLoading from '@/dashboard/components/loading/LogoLoading';
import PolicyModel from '@/dashboard/models/policys/PolicyModel';
import { TextFieldControlled } from '@/dashboard/mui/form/TextField';
import { usePolicyStore } from '@/dashboard/store/PolicyStore';
import { apiConfirmUpdatePolicy } from '@jove-frontend/uikit';
import { LoadingButton } from '@mui/lab';
import { Box, Button, Typography } from '@mui/material';
import { FormProvider, useForm } from 'react-hook-form';

type AddErnDialogProps = CustomDialogProps & {
  policy: PolicyModel;
};
const AddErnDialog = (props: AddErnDialogProps) => {
  const { close, policy } = props;
  const methods = useForm({
    defaultValues: {
      ern: policy?.payload?.['ern'],
    },
  });
  const { register, getValues, control, handleSubmit } = methods;
  const [loading, setLoading] = useState(false);
  const [{ fetchPolicies }] = usePolicyStore(({ actions }) => [actions]);

  const closeAction = () => {
    if (close) close();
  };

  /**
   * request
   */
  const requestAddErn = async () => {
    const params = {
      policy_id: policy.id,
      ern: getValues('ern'),
    };

    setLoading(true);
    const [res] = await apiConfirmUpdatePolicy(params);
    setLoading(false);
    if (res) {
      fetchPolicies();
      closeAction();
    }
  };

  /**
   * methods
   */

  // save
  const saveAction = () => {
    handleSubmit(requestAddErn)();
  };

  return (
    <FormProvider {...methods}>
      <form className="relative">
        {loading && <LogoLoading />}
        <Box className="flex flex-col">
          <Typography className="text-black-secondary mt-4 font-black" variant="h5">
            {!!policy?.payload?.['ern'] ? 'Update' : 'Add'} your ERN
          </Typography>
          <TextFieldControlled className="my-8" {...register('ern', { required: 'Please input' })} name="ern" control={control} />
          <Box className="flex flex-row items-center justify-end">
            <Button className="text-brand-primary text-lg font-bold" variant="text" onClick={closeAction}>
              Cancel
            </Button>
            <LoadingButton className="ml-2 h-12 w-[110px] rounded-full text-lg font-bold" color="primary" onClick={saveAction} loading={loading} loadingIndicator="Loading..." variant="contained">
              <span>Save</span>
            </LoadingButton>
          </Box>
        </Box>
      </form>
    </FormProvider>
  );
};

export default AddErnDialog;
